var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4684_51027)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4684_51027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.53268 3.59948C6.53268 3.79503 6.45935 3.96615 6.31268 4.11281L2.42602 7.99948L6.31268 11.8861C6.60602 12.1795 6.60602 12.6439 6.31268 12.9128C6.01935 13.2061 5.5549 13.2061 5.28602 12.9128L0.886016 8.51281C0.592682 8.21948 0.592682 7.75503 0.886016 7.48615L5.28602 3.08615C5.57935 2.79281 6.04379 2.79281 6.31268 3.08615C6.45935 3.23281 6.53268 3.40392 6.53268 3.59948Z",
    fill: "#F8F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3335 2.91425V13.0831C15.3335 14.3298 14.3313 15.332 13.0846 15.332H10.1513C9.73575 15.332 9.41797 15.0143 9.41797 14.5987C9.41797 14.1831 9.73575 13.8654 10.1513 13.8654H13.0846C13.5246 13.8654 13.8669 13.5231 13.8669 13.0831V2.91425C13.8669 2.47425 13.5246 2.13203 13.0846 2.13203H10.1513C9.73575 2.13203 9.41797 1.81425 9.41797 1.3987C9.41797 0.983143 9.73575 0.665365 10.1513 0.665365H13.0846C14.3313 0.665365 15.3335 1.66759 15.3335 2.91425Z",
    fill: "#F8F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5917 7.99714C11.5917 8.41269 11.2739 8.73047 10.8584 8.73047H2.1806C1.76504 8.73047 1.44727 8.41269 1.44727 7.99714C1.44727 7.58158 1.76504 7.2638 2.1806 7.2638L10.8584 7.2638C11.2739 7.2638 11.5917 7.58158 11.5917 7.99714Z",
    fill: "#F8F8FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4684_51027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(0 -1 1 0 0 16)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4684_51027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.6667,
    height: 14.6667,
    fill: "white",
    transform: "matrix(0 -1 1 0 0.666016 15.332)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.ea4cb48761dc2ba447889a4e1881fa7a.svg";
export { ForwardRef as ReactComponent };